import { VALIDATION_ERROR_MESSAGE, Yup } from "@mavichpe/dynamic-forms";

const ChangeProductTaxFormConfig = {
    submit: {
        label: "Actualizar"
    },
    sections: [
        {
            hideBorderBottom: true,
            "fields": [
                [
                    {
                        "type": "hidden",
                        "name": "documentId",
                    },
                    {
                        "type": "hidden",
                        "name": "documentType",
                    }
                ],
                [
                    {
                        "type": "number",
                        "name": "plazo",
                        "min": "1",
                        "isHorizontal": true,
                        "suffix": "dias",
                        "label": "Plazo",
                        "labelSizing": {
                            "md": 2,
                        },
                        "sizing": {
                            "md": 3,
                        },
                        "validation": Yup.string().required(VALIDATION_ERROR_MESSAGE.REQUIRED_FIELD_ERROR),
                    }
                ],
            ]
        }
    ],
};


export default ChangeProductTaxFormConfig;